// removed by extract-text-webpack-plugin
module.exports = {"button":"button-1Gls-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/buttons/base-button/base-button.less
 ** module id = 155
 ** module chunks = 0
 **/